import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const imageIcon = createIconDefinition(
  'image',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 4.16667V15.8333H4.16667V4.16667H15.8333ZM9.28333 13.1083L11.7833 9.88333L15 14.1667H5L7.5 10.95L9.28333 13.1083Z" fill="#232426" fill-opacity="0.6"/>
</svg>
`,
);
